import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-col-ter" }
const _hoisted_2 = { class: "title" }

import Tooltip from '@/components/common/Tooltip.vue'
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('已成功创建寻源单')), 1),
    _createVNode(Tooltip, { tooltip: "まだ、対応開始されていません。管理画面で内容確認の上、依頼提出をお願いします" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "commit mt_50",
          round: "",
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('SourcingOEM'))))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('查看寻源单列表')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})